var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{class:{
        'custom-card': true,
        'card-primary': _vm.cardTheme === 'primary',
        'card-warning': _vm.cardTheme === 'warning',
        'card-teal': _vm.cardTheme === 'teal',
    },attrs:{"tile":"","elevation":"0"}},[(!!_vm.$slots.title)?_c('v-card-title',[_vm._t("title")],2):_vm._e(),(!!_vm.$slots.subtitle)?_c('v-card-subtitle',[_vm._t("subtitle")],2):_vm._e(),_c('span',{staticClass:"card-tag subtitle-2 font-weight-regular"},[_vm._t("cardTag")],2),(!!_vm.$slots.content)?_c('div',{staticClass:"px-4 pb-4"},[_vm._t("content")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }